import {object} from 'yup';
import {BASE_URL} from '../config';
import {fetch} from '@app/apiFunction';
import axios from '../utils/axios';

export const getAllProjectNames = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/all-project-name';
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getUserAssignedProjects = async (userId) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/all-assigned?userId='+userId;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getAllProjectsForSearching = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/get-all';
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getAllProjectsForSearchingForDeveloper = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/get-project-allowed-only-developer';
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getAllProjects = async (query) => {
  var requestQuery = '';
  if (query) {
    requestQuery = Object.keys(query)
      .filter((v) => {
        return query[v] !== '';
      })
      .map((v) => {
        return `${v}=${query[v]}`;
      })
      .join('&');
  }

  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/get-all?' + requestQuery;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getAllProjectsAllowedForDevelopers = async (query) => {
  let requestQuery = '';
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      requestQuery = `${key}=${value}`;
    }
  }

  const token = localStorage.getItem('token');
  const url = BASE_URL + '/project/all-projects/dev?' + requestQuery;
  const type = 'get';
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getProjectById = async (projectId) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/' + projectId;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getSingleProjectForDeveloper = async (projectId) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/project/single-project/dev/' + projectId;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const createProject = async (payloadGet) => {
  const result = JSON.stringify(payloadGet);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/project/create';
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const getProjectFilesById = async (projectId, pageNo) => {
  if (pageNo === undefined) {
    pageNo = 1;
  }
  const token = localStorage.getItem('token');
  const type = 'get';
  const url =
    BASE_URL + '/file/get-all-files/' + projectId + '?pageNo=' + pageNo;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getProjectFilesForDeveloper = async (projectId, pageNo) => {
  if (pageNo === undefined) {
    pageNo = 1;
  }
  const token = localStorage.getItem('token');
  const type = 'get';
  const url =
    BASE_URL + '/file/get-all-files/dev/' + projectId + '?pageNo=' + pageNo;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getDocumentationFilesById = async (projectId, pageno) => {
  if (pageno === undefined) {
    pageno = 1;
  }

  const token = localStorage.getItem('token');
  const type = 'get';
  const url =
    BASE_URL + '/documentation/docs/' + projectId + '?pageNo=' + pageno;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getDocumentationAllowedOnlyDeveloper = async (
  projectId:any,
  pageno:any
) => {
  if (pageno === undefined) {
    pageno = 1;
  }

  const token = localStorage.getItem('token');
  const type = 'get';
  const url =
    BASE_URL + '/documentation/dev/docs/' + projectId + '?pageNo=' + pageno;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const documentUpdateDocs = async (isPublic, assignedTo, docId) => {
  if (assignedTo === null) {
    var assignedUser = [];
  } else {
    assignedUser = assignedTo.map((val) => {
      return val.value;
    });
  }

  const payloadGet = {
    isPublic: isPublic,
    assignedTo: assignedUser
  };
  const result = JSON.stringify(payloadGet);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/documentation/update-docs/' + docId;
  const payload = payloadGet;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const updateProject = async (payloadGet, projectId) => {
  const result = JSON.stringify(payloadGet);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/project/update/' + projectId;
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};
